import { useState } from "react";
import { DateSettings } from "./customPropertyConfig";
import { MySwitch } from "../../shared/MySwitch";

type AppCustomPropertySettingsDateProps = {
    settings: DateSettings;
    onChange: (settings: DateSettings) => void;
}

export const AppCustomPropertySettingsDate = ({settings, onChange} : AppCustomPropertySettingsDateProps) => {
    return (
        <div className="app-custom-property-settings-container">
            { }
        </div>
    )
}